import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { IHorario } from "interfaces/horarios";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_BOOKING_" }
);

export interface ListBookingState extends IState {
  data: IHorario[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: IHorario[];
}

const INITIAL_STATE: ListBookingState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListBookingState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListBookingState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListBookingState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listBooking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListBookingTypes = Types;
export const ListBookingActions = Creators;
